import { useState } from "react";
import {
    StandardModal,
    StandardModalBody,
    StandardModalHeader,
} from "../general/Modal/Modal";
import { getImporterReconciliationQueue } from "../../common/helpers/financialDocument";
import { FinancialAccount } from "../../common/types/financialAccount";
import { getAnonymousAccountNumber } from "../../common/helpers/bankAccount";
import { ImporterContextProvider } from "../importer/ImporterContextProvider";
import { Importer } from "../importer/Importer";
import { ReconciliationTransactionsReview } from "./ReconciliationTransactionsReview";
import { ReconciliationContextProvider } from "./ReconciliationContextProvider";

interface Props {
    show: boolean;
    reconciledFinancialAccount: FinancialAccount;
    onHide: () => void;
}

enum ReconciliationStep {
    Import = "import",
    Review = "review",
}

export const ReconciliationModal: React.FC<Props> = ({
    show,
    reconciledFinancialAccount,
    onHide,
}) => {
    const title = `Reconcile ${reconciledFinancialAccount.institutionName} ${getAnonymousAccountNumber(reconciledFinancialAccount.accountNumberMask ?? "", 2)}`;
    const importerQueue = getImporterReconciliationQueue(
        reconciledFinancialAccount.id,
    );
    const [step, setStep] = useState<ReconciliationStep>(
        ReconciliationStep.Import,
    );

    return (
        <StandardModal fullscreen onHide={onHide} show={show}>
            <StandardModalHeader>{title}</StandardModalHeader>
            <StandardModalBody>
                <ImporterContextProvider
                    importerQueue={importerQueue}
                    reconciledFinancialAccount={reconciledFinancialAccount}
                >
                    <ReconciliationContextProvider>
                        {step === ReconciliationStep.Import && (
                            <Importer
                                onHide={onHide}
                                onNext={() =>
                                    setStep(ReconciliationStep.Review)
                                }
                            />
                        )}
                        {step === ReconciliationStep.Review && (
                            <ReconciliationTransactionsReview
                                financialAccount={reconciledFinancialAccount}
                                onBack={() =>
                                    setStep(ReconciliationStep.Import)
                                }
                                onHide={onHide}
                            />
                        )}
                    </ReconciliationContextProvider>
                </ImporterContextProvider>
            </StandardModalBody>
        </StandardModal>
    );
};
